import { useTranslation } from 'react-i18next';

import useStyles from './styles';

function NameList({ id, n }: { id: string; n: number }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const nums = [...Array(n).keys()];

  return (
    <ul className={classes.nameList}>
      {nums.map((i) => {
        const text = t(`emojiPage.${id}.nameList.${i}`);

        return <li key={text}>{text}</li>;
      })}
    </ul>
  );
}

export default NameList;
